import {productItem, renderRatingHTML} from "./renderProductInfo.js";
import {getElement, removeActive} from "../modules/helpers.js";
import {configurationProductSlider} from "./productPageSliders.js";
import {catalogItemSlider} from "../catalogItem/catalogItem.js";
import {searchVariations} from '../productPage/renderProductInfo.js'
import scrollToAnchor from "../modules/scrollToAnchor.js";
import {formLinkAttr, renderStockStatus} from "../catalogItem/catalogItem.js";
import smoothHeight from "../modules/smoothHeight.js";


export default function renderProductItem() {

    const {addons, recommended} = product;
    const currentCurrency = product.currency;

    if (addons || recommended) {
        const includesNav = productItem.querySelector('.scroll__wrapper');
        if (addons && addons.length !== 0) {
            includesNav.appendChild(renderConfigurationItemNav('Upgrade with add-ons', addons.length, '#addons'));
            const includesParent = getElement('[data-includes="addons"]').querySelector('.swiper-wrapper');
            getElement('#addons').querySelector('.quantity').innerText = addons.length;
            includesParent.appendChild(renderConfigurationItem(addons, 'addons'));
            configurationProductSlider('addons');

        }
        if (recommended && recommended.length !== 0) {
            includesNav.appendChild(renderConfigurationItemNav('Recommendations', recommended.length, '#recommended'));
            const includesParent = getElement('[data-includes="recommended"]').querySelector('.swiper-wrapper');
            getElement('#recommended').querySelector('.quantity').innerText = recommended.length;
            includesParent.appendChild(renderConfigurationItem(recommended, 'recommended'));
            configurationProductSlider('recommended');

        }

        document.querySelectorAll('[data-catalog-item]').forEach(itemCatalog => {
            const gallery = itemCatalog.querySelector('.catalog-item__gallery');
            itemCatalog.querySelectorAll('.catalog-item__image').forEach(catalogItemImage => {
                catalogItemImage.querySelector('img').classList.add('swiper-lazy');
            })
            catalogItemSlider(gallery.dataset.swiper)


        })


        document.querySelectorAll('.catalog-item__descr').forEach(item => {
            const attrWrapper = item.querySelector('.catalog-item__filters');

            if (attrWrapper.querySelectorAll('[data-select-item]').length == 1 || attrWrapper.children.length == 0) {
                attrWrapper.classList.add('none');
            }
        })
        scrollToAnchor();
    }

    function renderConfigurationItemNav(txt, count, target) {
        const div = document.createElement('div');
        div.classList = "product-item__includes  product-item--line border--bottom";
        div.innerHTML = ` 
        <div class="flex --just-between  --align-center">
            <div class="mr-10">${txt} <span class="text-color__black--60">${count}</span></div>
            <a href="${target}" class="flex --align-center scroll-to text-color__black--60" >
            <span class="mr-5">Explore</span>
            <span class="icon-arrow-right icon-12"></span>
            </a>
        </div>`
        return div;


    }

    function renderConfigurationItem(arr, slug) {
        const fragment = document.createDocumentFragment();
        arr.forEach(item => {
            if (!item) return;
            const {
                productId,
                title,
                price,
                regularPrice,
                currency,
                comments,
                rating: {rating},
                link,
                attributes: {defaultAttributes},
                variations, thumbnail, isHelmet, plate
            } = item;
            const div = document.createElement('div');
            div.classList = 'catalog-item pos-r include-item';
            if (arr.length == 1) {
                div.style.maxWidth = '35rem';
                if (matchMedia("(max-width: 700px)").matches) {
                    div.style.maxWidth = '100%';
                }
            }
            div.dataset.catalogItem = productId;
            div.dataset.productThumbnail = thumbnail;
            div.dataset.productId = productId;
            div.dataset.subproduct = slug;
            div.dataset[slug] = productId;
            div.innerHTML = `   
          <div class="catalog-item__preview flex --dir-col ," >
            <div class="catalog-item__header">
              <div class="reviews mb-5 flex --align-center --just-between ">
                <div class="flex --align-center">
                <div class="stars flex --align-center">
                
                </div>         
                  <span class="ml-5">${rating}</span>
                </div>
                <a href="${link}#reviews" class="flex --align-center scroll-to">
                  <span data-revies="${comments.length > 0 ? comments.length : 0}" class="mr-5">${comments.length > 0 ? comments.length : 0}</span>
                  <span>reviews</span>
                  <span class="icon-arrow -right icon-14"></span>
                </a>
              </div>
              <div class="labels mb-15 flex">
        
               <div class="label mr-5  label--light-gray"><span data-product-discount="" class="mr-5">%</span>
       <span>Off</span></div>
              </div>
            </div>
            <div class="catalog-item__gallery  pos-r swiper__nav" data-swiper="${slug}-${productId}">
              <div class="swiper-wrapper  mb-20 ">
              </div>
                <button class="prev slider__prev-catalog-item-id-${slug}-${productId}"><span class="arrow arrow--left">
            <span class="icon-arrow-right"></span>
          </span>
                </button> <button class="next slider__next-catalog-item-id-${slug}-${productId}"><span class="arrow ">
            <span class="icon-arrow-right"></span>
          </span></button>
            </div>
            <div class="catalog-item__title catalog-item--line border--bottom ">
              <a href="${link}" class="h2 fw-600 mb-5 txt-no-underline text-color__black" data-product-title data-href>
                ${title}
              </a>
              <div class="price mb-10 text-color__black--60 flex --align-end  ">
                <div   class="h2 fw-600 mr-10 m" data-product-price="${price}" >${Math.ceil(+price)}</div>
                <s data-price-old="${regularPrice}">${regularPrice !== '' && price != regularPrice ? Math.ceil(+regularPrice) : ''}</s>

              </div>
              <div class="flex --just-between --align-center" data-attributes>
                <div class="colors flex ${plate ? 'none' : ''}" data-select="pa_color">
                 ${renderColors(item) ? renderColors(item) : '<div data-pa_color="" data-select-item class="active">No available colors </div>'}
             
                </div>
                <button class="h2 ml-auto">
                  <span class="icon-wishlist icon-30"></span>
                </button>
              </div>
                <div class="catalog-item__btn-mobile">
              <button class="btn btn--outline-black w-100" data-modal="config">
                Add to cart
              </button>
            </div>



            </div>
          </div>


          <div class="catalog-item__descr ">

            <div class=" catalog-item--line border--bottom labels flex" >
              <div class="label label--green "data-product-stock><svg class="icon mr-5">
              

              </div>
            </div>
            <div class="catalog-item__filters  border--bottom " data-attributes>
            ${renderAttributes(item)}
        
            </div>
            <div class="catalog-item__btn">
              <button class="btn btn--outline-black w-100" data-modal="config">
                Add to cart
              </button>
            </div>



          </div>

     
    `;
            renderRatingHTML(div, rating)
            const defaultItem = findVariationInProducts(defaultAttributes, item) ? findVariationInProducts(defaultAttributes, item) : variations[0];
            div.querySelectorAll('[data-attributes]').forEach(
                attributes => {
                    if (!defaultItem) return;
                    renderActiveAttributes(attributes.querySelectorAll('[data-select]'), defaultItem, item)
                    div.dataset.variationHref = `${link}?${formLinkAttr(div)}`
                    const {price, regular_price} = defaultItem
                    div.querySelector('.price').innerHTML = `
             <div data-product-price="${price}" data-price-new="${price}" class=" h2 fw-600 mr-10">${currentCurrency}${Math.ceil(+price)}</div>
                <s data-price-old="${regular_price}">${regular_price !== '' && price != regular_price ? currentCurrency + Math.ceil(+regular_price) : ''}</s>
        `;
                    let discount = Math.round((1 - +price / +regular_price) * 100);

                    if (Math.round((1 - +price / +regular_price) * 100)) {
                        if (div.querySelector('[data-product-discount]').parentElement.classList.contains('none')) {
                            div.querySelector('[data-product-discount]').parentElement.classList.remove('none')
                        }

                        div.querySelector('[data-product-discount]').innerText = `${discount}%`
                    } else {
                        div.querySelector('[data-product-discount]').parentElement.classList.add('none')
                    }

                    renderStockStatus(div, defaultItem)
                    attributes.querySelectorAll('[data-select]').forEach(select => {
                        select.querySelectorAll('[data-select-item]').forEach(selectItem => {
                            selectItem.addEventListener('click', () => {
                                removeActive(select.querySelectorAll('[data-select-item]'));
                                selectItem.classList.add("active");
                                if (selectItem.dataset.pa_size) {
                                    if (getElement('[data-select=pa_cummerbund-size]')) {
                                        getElement('[data-select=pa_cummerbund-size]').querySelectorAll('[data-select-item]').forEach(cummerbundSizeItem => {
                                            removeActive(getElement('[data-select=pa_cummerbund-size]').querySelectorAll('[data-select-item]'));
                                            cummerbundSizeItem.classList.add("active");
                                        })
                                    }

                                }
                                getVariationFromAttributes(div, item);
                                renderActiveAttributes(attributes.querySelectorAll('[data-select]'), objectAttributesCreate(div), item);

                                div.querySelectorAll('[data-href]').forEach(a => {
                                    a.href = `${link}?${formLinkAttr(div)}`;
                                    div.dataset.variationHref = `${link}?${formLinkAttr(div)}`;
                                })

                            })
                        })
                    })

                })
            if (plate) {
                let linkStr = ''
                div.querySelector('[data-select="pa_size"]').querySelectorAll('[data-pa_size]').forEach(activeAttr => {
                    if (activeAttr.classList.contains('active')) {
                        linkStr = activeAttr.dataset.pa_size;
                    }
                })

                plate.forEach(plateItem => {
                    const {name, links} = plateItem
                    if (name == 'type') {
                        const divEl = document.createElement('div')

                        const btns = function () {
                            let fragment = ``;

                            links.forEach((link) => {
                                const {attrName, href, id} = link;
                                if (id == productId) {
                                    return fragment += `
                  <button class="switcher__item border-black active h3 fw-600">  <span>${attrName}</span></button>
                `
                                }
                                return fragment += `
                  <a href="${href}?attribute_pa_size=${linkStr}" class="switcher__item txt-no-underline h3 fw-600">  <span>${attrName}</span></a>
                `
                            })
                            return fragment
                        }

                        divEl.classList = `switcher flex br--6 `;
                        divEl.dataset.plate = true;
                        divEl.innerHTML = btns();
                        div.querySelector('[data-select="pa_color"]').insertAdjacentElement('beforebegin', divEl)
                    }
                })

            }


            const gallery = div.querySelector('.catalog-item__gallery').querySelector('.swiper-wrapper');
            div.querySelector('[data-select="pa_color"]').querySelectorAll('[data-select-item]').forEach(colorBtn => {

                if (colorBtn.classList.contains('active')) {
                    gallery.innerHTML = renderSwiperImages(item, colorBtn.dataset.pa_color);
                    gallery.querySelectorAll('.catalog-item__image').forEach(galleryItem => {
                        galleryItem.querySelector('img').classList.add('swiper-lazy')
                    })
                    gallery.parentElement.insertAdjacentHTML('beforeend', `<div class="swiper-pagination"></div>`)
                    catalogItemSlider(gallery.parentNode.dataset.swiper);


                }
                colorBtn.addEventListener('click', () => {
                    gallery.innerHTML = renderSwiperImages(item, colorBtn.dataset.pa_color);
                    gallery.querySelectorAll('.catalog-item__image').forEach(galleryItem => {
                        galleryItem.querySelector('img').classList.add('swiper-lazy')
                    })
                    catalogItemSlider(gallery.parentNode.dataset.swiper);
                    //
                })


            });


            div.querySelectorAll('[data-href]').forEach(a => {
                a.href = div.dataset.variationHref;
            })
            //
            fragment.appendChild(div);

        })
        return fragment;


    }


}

function renderProductLabels(item) {

    const {discount, low_stock} = item;
    if (discount || low_stock) {
        if (discount) {
            return `  <div class="label mr-5 label--orange text-color__white">${discount} Off</div>`
        }
        if (low_stock) {
            return `<div class="label mr-5 label--gray label--blur  text-color__white">
        Low Stock
    </div>`
        }
    } else {
        return '';
    }


}

function renderActiveAttributes(attributesElements, obj, product = {}) {
    if (!obj) return;
    attributesElements.forEach(item => {
        item.parentNode.closest('[data-product-id]').dataset.productId = obj.id
        const btns = item.querySelectorAll('[data-select-item]');
        btns.forEach(btn => {
            for (let key in obj.attributes) {
                if (key === item.dataset.select) {
                    if (btn.getAttribute(`data-${key}`) === obj.attributes[key]) {
                        btn.classList.add('active');
                    }
                }
            }
            if (product) {
                let attr = obj.attributes ? obj.attributes : obj
                let variationsItems = searchVariations(attr, product.variations);
                if (variationsItems.length == 0) {
                    if (!btn.classList.contains('active')) {
                        btn.classList.add('disabled')
                    }
                    return;
                }
                variationsItems.forEach(varItem => {
                    const {attributes} = varItem;
                    if (btn.classList.contains('disabled')) btn.classList.remove('disabled');
                    for (let key in attributes) {
                        const valuesArray = variationsItems.map(obj => obj.attributes[key]);
                        if (!btn.classList.contains('active') && btn.getAttribute(`data-${key}`) && !valuesArray.includes(btn.getAttribute(`data-${key}`))) {
                            btn.classList.add('disabled')
                        }
                    }
                })
            }

        });
    })
}

function renderActiveAttributesWithPrice(attributesElements, obj, startPrice, mainProduct) {
    attributesElements.forEach(item => {
        const itemParent = item.parentNode.closest('[data-product-id]');
        const quantity = +itemParent.querySelector('[data-price-new]').dataset.productQuantity;
        const {price, regular_price} = obj
        itemParent.querySelector('[data-price-new]').innerHTML = `${mainProduct.currency}${Math.ceil(+price) * quantity}`
        itemParent.querySelector('[data-price-new]').dataset.productPrice = Math.ceil(+price) * quantity;
        itemParent.querySelector('[data-price-old]').dataset.priceOld = Math.ceil(+price) * quantity;
        itemParent.querySelector('[data-price-old]').innerHTML = price !== regular_price ? mainProduct.currency + Math.ceil(+regular_price) * quantity : '';
        const btns = item.querySelectorAll('[data-select-item]');
        btns.forEach(btn => {
            for (let key in obj.attributes) {
                if (key === item.dataset.select) {
                    if (btn.getAttribute(`data-${key}`) === obj.attributes[key]) {
                        btn.classList.add('active');
                        if (btn.children.length > 1) {
                            btn.lastChild.textContent = 'Included';
                        } else {
                            btn.insertAdjacentHTML('beforeend', `<span>Included</span>`)
                        }
                    }
                }
            }
            let variationsItems = searchVariations(obj.attributes, mainProduct.variations);
            variationsItems.forEach(varItem => {
                //TODO regularPrice = regular_price - change
                const {price, regular_price, attributes} = varItem;
                for (let key in attributes) {
                    if (btn.getAttribute(`data-${key}`) === attributes[key] && !btn.classList.contains('active')) {
                        let value = 0;
                        if (+startPrice > +price) {
                            value = (+startPrice - +price).toFixed(2);
                            value = `-${mainProduct.currency}${Math.ceil(value)}`
                        } else if (+startPrice < +price) {
                            value = (+price - +startPrice).toFixed(2);
                            value = `+${mainProduct.currency}${Math.ceil(value)}`
                        } else {
                            value = ``
                        }
                        if (btn.children.length > 1) {
                            btn.lastChild.innerHTML = `<span>${value}</span>`;

                        } else {
                            btn.insertAdjacentHTML('beforeend', `<span>${value}</span>`);

                        }
                        return;
                    }

                }
            })

        });

    })


}

function objectAttributesCreate(div) {
    let objectAttributes = {};
    if (!div) return;
    div.querySelectorAll('[data-attributes]').forEach(
        item => {
            item.querySelectorAll('[data-select]').forEach(select => {

                select.querySelectorAll('[data-select-item]').forEach(selectItem => {
                    if (selectItem.classList.contains('active') && selectItem.getAttribute(`data-${select.dataset.select}`)) {
                        objectAttributes[select.dataset.select] = selectItem.getAttribute(`data-${select.dataset.select}`)
                    }
                })
            })

        });

    return objectAttributes;
}

function getVariationFromAttributes(div, product) {
    let obj = objectAttributesCreate(div);
    let newVariation = findVariationInProducts(obj, product);
    const priceParent = div.querySelector('.price');
    const {price, regular_price} = newVariation;
    div.dataset.productId = newVariation.id;
    priceParent.innerHTML = `
             <div data-price-new="${price}" data-product-price="${price}" class=" h2 fw-600 mr-10">${product.currency}${Math.ceil(+price)}</div>
                <s data-price-old="${regular_price}">${regular_price !== '' && price != regular_price ? product.currency + Math.ceil(+regular_price) : ''}</s>
        `
    renderStockStatus(div, newVariation);
    let discount = Math.round((1 - +price / +regular_price) * 100);

    if (Math.round((1 - +price / +regular_price) * 100)) {
        if (div.querySelector('[data-product-discount]').parentElement.classList.contains('none')) {
            div.querySelector('[data-product-discount]').parentElement.classList.remove('none')
        }

        div.querySelector('[data-product-discount]').innerText = `${discount}%`
    } else {
        if (div.querySelector('[data-product-discount]')) div.querySelector('[data-product-discount]').parentElement.classList.add('none')

    }
    if (div.querySelector('[data-plate]')) {
        div.querySelector('[data-plate]').querySelectorAll('a').forEach(a => {
            const linkStr = a.href
            const [href] = linkStr.split('?attribute_pa_size=');
            a.href = `${href}?attribute_pa_size=${obj.pa_size}`
        })
    }

}

function getVariationFromAttributesWithPrice(div, product) {
    let obj = objectAttributesCreate(div);
    let newVariation = findVariationInProducts(obj, product);
    const {price, regular_price} = newVariation;
    let newPrice = +price !== +regular_price ? price : regular_price;
    div.dataset.productId = newVariation.id;
    div.querySelectorAll('[data-attributes]').forEach(element => {
        renderActiveAttributesWithPrice(element.querySelectorAll('[data-select]'), newVariation, newPrice, product)
    })
    if (div.querySelector('[data-plate]')) {
        div.querySelector('[data-plate]').querySelectorAll('a').forEach(a => {
            const linkStr = a.href
            const [href] = linkStr.split('?attribute_pa_size=');
            a.href = `${href}?attribute_pa_size=${obj.pa_size}`
        })
    }
    renderStockStatus(div, newVariation);


}

function renderAttrButtons(values, attrName) {

    let fragment = '';
    values.forEach((item) => {
        const {slug, value} = item;
        fragment += `
       <li class="list__item" data-${attrName}="${slug}" data-select-item>
     ${value}
   </li>
    `;
    })

    return fragment;


}

function renderSwiperImages(product, color) {
    let fragment = '';
    const {images: {photos, gallery, fieldFootage}, link, plate, productId} = product;
    let galleryArr = [];
    if (!photos) return;
    if (plate) {
        gallery.forEach(item => {
            if (item.main) {
                galleryArr = [item.main];
            }
        });
    }
    photos.forEach(item => {
        if (item.slug && item.slug === color) {
            if (!item.colors) return
            const {colors} = item;
            colors.forEach(colorItem => {
                if (colorItem && colorItem.img) {
                    const {img} = colorItem;
                    if (galleryArr.length == 4) return;
                    galleryArr = [...galleryArr, img];
                }

            })
        }
    });
    if (!plate) {
        gallery.forEach(item => {
            if (item.main && galleryArr.length < 4) {
                galleryArr = [...galleryArr, item.main];
            }
        });
    }
    gallery.forEach(item => {
        if (!item.img) return;
        if (galleryArr.length == 4) return;
        galleryArr = [...galleryArr, item.img];
    });
    const imagesItems = 4 - galleryArr.length;
    if (imagesItems) {
        let count = 0;
        fieldFootage.forEach(item => {
            if (item && count < imagesItems) {
                galleryArr = [...galleryArr, item.img];
                count++;
            }
        })

    }
    galleryArr.forEach(img => {
        fragment += `
       <a href="${link}" class="catalog-item__image pos-r" data-href>
       <div class="image">
   ${img}
      </div>
      <div class="swiper-lazy-preloader"></div>
   
    </a>
      `

    })

    catalogItemSlider()


    return fragment;
}

function findVariationInProducts(findObj, item) {
    let object = {...findObj};
    const {variations} = JSON.parse(JSON.stringify(item));
    return variations.find(variation => {
        const {attributes} = variation;
        if (!isLogin && attributes['pa_cummerbund-size']) {
            object['pa_cummerbund-size'] = object['pa_size']
        }
        if (object && Object.keys({...object}).every(key => object[key] == attributes[key])) {
            return variation
        }

    })
}

function variationFromLoop(array, object) {
    return array.find(variation => {

        const {attributes} = variation;
        if (!isLogin && attributes['pa_cummerbund-size']) {
            object['pa_cummerbund-size'] = object['pa_size']
        }
        if (object && Object.keys({...object}).every(key => object[key] == attributes[key])) {
            return variation
        }

    })
}

function findVariationInFilteredProducts(findObj, item) {

    let object = {...findObj};
    const {variations} = item;
    let currentVariation;
    if (+object.from) {
        let art = variations.filter(variation => {
            const {attributes} = variation;
            if (attributes['pa_cummerbund-size']) {
                if (attributes['pa_cummerbund-size'] == attributes['pa_size'] && +variation.price >= +object.from) return variation;
            } else {
                return +variation.price >= +object.from;
            }
        })
        currentVariation = art.find(variation => {
            const {attributes} = variation;
            if (attributes['pa_cummerbund-size']) {
                object.attributes['pa_cummerbund-size'] = object.attributes['pa_size']
            }
            if (object.attributes && Object.keys({...object.attributes}).every(key => object.attributes[key] == attributes[key])) return variation;

            //
            //     if (object && Object.keys({...object}).every(key => object[key] == attributes[key])) return variation;
        })
        if (!currentVariation) {
            currentVariation = art.find(variation => {
                const {attributes} = variation;
                return Object.keys({...object.attributes}).find(key => {
                    if (key == 'pa_color') {
                        if (object.attributes[key] == attributes[key]) {
                            if (attributes['pa_size']) {
                                if (attributes['pa_size'] && object.attributes['pa_size'] == attributes['pa_size']) return variation
                            } else {
                                return variation;
                            }
                        }

                    }
                    if (key == 'pa_size') {
                        if (object.attributes[key] == attributes[key]) return variation;
                    }
                    return variation;

                })
                // Object.keys({...object.attributes}).find(key => {
                //     console.log(object.attributes[key], object.attributes, attributes[key])
                // })
                // if (Object.keys({...object.attributes}).find(key => object.attributes[key] == attributes[key])) return variation
            })


        }
        return currentVariation;

    }

}

function renderColors(item) {
    const {attributes: {allAttributes}} = item;
    let colors;
    let fragment = '';
    for (let key in allAttributes) {
        const itemAttr = allAttributes[key];
        for (let keyItem in itemAttr) {
            if (keyItem == 'pa_color') {
                const {values} = itemAttr[keyItem];
                colors = [...values];

            }
        }
    }
    ;

    if (colors) {
        colors.forEach(color => {
            const {value, slug, pattern} = color;
            fragment += `
    <button class="color image" data-pa_color="${slug}" data-select-item>
    <img src="${pattern}" alt="${value}">
    
                        <svg class="icon">
                          <use xlink:href="#check"></use>
                        </svg>
                      </button>
    `
        })
    }

    return fragment

}


function renderAttributes(item) {
    const {attributes: {variationsAttributes, allAttributes}} = JSON.parse(JSON.stringify(item));
    let fragment = ``;
    const renderAttributes = allAttributes.filter(item => {
        for (let key of variationsAttributes) {
            if (key == Object.keys(item)[0]) {
                return item;
            }
        }
    });
    renderAttributes.forEach(attr => {
        for (let key in attr) {
            const {attrName, label, values} = attr[key];

            if (key !== 'pa_color') {
                fragment += `
        <div class="flex catalog-item__info fw-400  ${values.length == 1 || key == "pa_cummerbund-size" ? 'none' : ''}" data-select="${attrName}">
                <div class="name text-color__black--60 mr-5 ">${label}</div>
                <ul class="list flex">
              ${renderAttrButtons(values, attrName)}
                </ul>
              </div>
`

            }

        }

    })
    return fragment;

}

export {
    renderSwiperImages,
    findVariationInProducts,
    renderColors,
    renderAttributes,
    getVariationFromAttributes,
    renderActiveAttributes,
    getVariationFromAttributesWithPrice,
    renderActiveAttributesWithPrice, renderProductLabels, objectAttributesCreate, findVariationInFilteredProducts

}